import { useMemo } from 'react'
import SafeSearchBar from '@/common/components/SafeSearchBar'
import BandaCuentaConectada from '../components/BandaCuentaConectada.jsx'
import CuentasSeleccionTable from '../components/CuentasSeleccionTable.jsx'
import EncabezadoSeleccionCuenta from '../components/EncabezadoSeleccionCuenta.jsx'
import ToastSeleccionCuenta from '../components/ToastSeleccionCuenta.jsx'
import { useCuentasSeleccion } from '../hooks/useCuentasSeleccion.js'
import { useIngresarCuenta } from '../hooks/useIngresarCuenta.js'
import { useToast } from '../hooks/useToast.js'
import { buildCuentasSeleccionRows } from '../util/buildCuentasSeleccionRows.jsx'
import { TEXTOS } from '../constants/textos.js'

/**
 * Selección de cuenta para usuarios comunes y administradores de empresa
 * (PBI #80498): grilla con las cuentas asociadas al usuario.
 */
export default function SeleccionCuentaUsuario() {
  const { toast, mostrarMensaje, cerrarToast } = useToast()

  const {
    cuentas,
    cuentaActiva,
    contratoActivo,
    headers,
    isLoading,
    error,
    searchValue,
    setSearchValue,
    hayFiltroAplicado,
    onPageChange,
  } = useCuentasSeleccion()

  const { ingresarCuenta, contratoIngresando, ingresoEnCurso } = useIngresarCuenta({ onMensaje: mostrarMensaje })

  const filas = useMemo(
    () =>
      buildCuentasSeleccionRows(cuentas, {
        contratoActivo,
        contratoIngresando,
        ingresoEnCurso,
        onIngresar: ingresarCuenta,
      }),
    [cuentas, contratoActivo, contratoIngresando, ingresoEnCurso, ingresarCuenta]
  )

  return (
    <>
      <BandaCuentaConectada razonSocial={cuentaActiva?.razonSocial} />

      <div className="mt-[20px] mx-[40px] lg:mx-[96px] pb-8">
        <EncabezadoSeleccionCuenta />

        <div className="mt-6 mb-4">
          <SafeSearchBar
            placeholder={TEXTOS.BUSCADOR_PLACEHOLDER}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            opciones={[]}
            setSelected={() => {}}
            cargando={false}
            noResult={false}
            classNameContainer="w-full md:w-[420px]"
          />
        </div>

        <CuentasSeleccionTable
          headers={headers}
          tableData={filas}
          onPageChange={onPageChange}
          isLoading={isLoading}
          hayFiltroAplicado={hayFiltroAplicado}
          error={error}
        />
      </div>

      <ToastSeleccionCuenta toast={toast} onClose={cerrarToast} />
    </>
  )
}
